export default "__VITE_ASSET__b76ca66a__"